import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import * as React from "react";
import { CLAIM_DOCUMENT_TYPES, statusActions } from "../../../ISchema";
import { uploadClaimDocument, deleteClaimDocument, fetchClaimDocuments } from "../claimActions";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";

var Step3 = function Step3(props) {
  var claim = props.claim,
      token = props.token;

  var _React$useState = React.useState(CLAIM_DOCUMENT_TYPES[0].value),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      selectedType = _React$useState2[0],
      setSelectedType = _React$useState2[1];

  var _React$useState3 = React.useState(false),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      isUploading = _React$useState4[0],
      setIsUploading = _React$useState4[1];

  var _React$useState5 = React.useState(""),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      error = _React$useState6[0],
      setError = _React$useState6[1];

  var queryClient = useQueryClient();

  var _useQuery = useQuery({
    queryKey: ['claimDocuments', claim.id],
    queryFn: function queryFn() {
      return fetchClaimDocuments(claim.id, token);
    },
    select: function select(response) {
      return response.status === "ok" ? response.payload : [];
    }
  }),
      claimDocuments = _useQuery.data,
      isLoading = _useQuery.isLoading;

  var uploadMutation = useMutation({
    mutationFn: function mutationFn(formData) {
      return uploadClaimDocument(claim.id, formData, token);
    },
    onSuccess: function onSuccess(response) {
      if (response.status === statusActions.ok) {
        queryClient.invalidateQueries({
          queryKey: ['claimDocuments', claim.id]
        });
        setIsUploading(false);
        setError("");
      } else {
        var _response$payload, _response$payload$err, _response$payload$err2;

        setError("Error al subir el documento: " + ((_response$payload = response.payload) === null || _response$payload === void 0 ? void 0 : (_response$payload$err = _response$payload.errors) === null || _response$payload$err === void 0 ? void 0 : (_response$payload$err2 = _response$payload$err.document) === null || _response$payload$err2 === void 0 ? void 0 : _response$payload$err2.join(", ")));
        setIsUploading(false);
      }
    },
    onError: function onError(error) {
      console.log(error.payload);
      setError("Error al subir el documento: " + error.payload.errors.join(", "));
      setIsUploading(false);
    }
  });
  var deleteMutation = useMutation({
    mutationFn: function mutationFn(documentId) {
      return deleteClaimDocument(claim.id, documentId, token);
    },
    onSuccess: function onSuccess() {
      queryClient.invalidateQueries({
        queryKey: ['claimDocuments', claim.id]
      });
    },
    onError: function onError() {
      setError("Error al eliminar el documento");
    }
  });

  var handleFileChange = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(event) {
      var _event$target$files;

      var file, formData;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              file = (_event$target$files = event.target.files) === null || _event$target$files === void 0 ? void 0 : _event$target$files[0];

              if (file) {
                _context.next = 3;
                break;
              }

              return _context.abrupt("return");

            case 3:
              setIsUploading(true);
              setError("");
              formData = new FormData();
              formData.append("claim_document[claim_id]", claim.id.toString());
              formData.append("claim_document[document]", file);
              formData.append("claim_document[type]", selectedType);
              uploadMutation.mutate(formData);

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleFileChange(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var handleDeleteDocument = function handleDeleteDocument(documentId) {
    deleteMutation.mutate(documentId);
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "claim-documents-step"
  }, /*#__PURE__*/React.createElement("div", {
    className: "upload-section mb-4"
  }, /*#__PURE__*/React.createElement("h4", null, "Subir nuevo documento"), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-6"
  }, /*#__PURE__*/React.createElement("select", {
    className: "form-control mb-3",
    value: selectedType,
    onChange: function onChange(e) {
      return setSelectedType(e.target.value);
    }
  }, CLAIM_DOCUMENT_TYPES.map(function (type) {
    return /*#__PURE__*/React.createElement("option", {
      key: type.value,
      value: type.value
    }, type.label);
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-md-6"
  }, /*#__PURE__*/React.createElement("input", {
    type: "file",
    className: "form-control",
    onChange: handleFileChange,
    disabled: isUploading
  })), isUploading && /*#__PURE__*/React.createElement("p", null, "Cargando documento...")), error && /*#__PURE__*/React.createElement("div", {
    className: "text-danger mt-2"
  }, error)), /*#__PURE__*/React.createElement("div", {
    className: "documents-list"
  }, /*#__PURE__*/React.createElement("h4", null, "Documentos subidos"), isLoading ? /*#__PURE__*/React.createElement("p", null, "Cargando documentos...") : (claimDocuments === null || claimDocuments === void 0 ? void 0 : claimDocuments.length) === 0 ? /*#__PURE__*/React.createElement("p", null, "No hay documentos subidos") : /*#__PURE__*/React.createElement("div", {
    className: "table-responsive"
  }, /*#__PURE__*/React.createElement("table", {
    className: "table"
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Tipo"), /*#__PURE__*/React.createElement("th", null, "Nombre"), /*#__PURE__*/React.createElement("th", null, "Fecha"), /*#__PURE__*/React.createElement("th", null, "Acciones"))), /*#__PURE__*/React.createElement("tbody", null, claimDocuments === null || claimDocuments === void 0 ? void 0 : claimDocuments.map(function (doc) {
    var _CLAIM_DOCUMENT_TYPES;

    return /*#__PURE__*/React.createElement("tr", {
      key: doc.id
    }, /*#__PURE__*/React.createElement("td", null, (_CLAIM_DOCUMENT_TYPES = CLAIM_DOCUMENT_TYPES.find(function (t) {
      return t.value === doc.type;
    })) === null || _CLAIM_DOCUMENT_TYPES === void 0 ? void 0 : _CLAIM_DOCUMENT_TYPES.label), /*#__PURE__*/React.createElement("td", null, doc.document_name), /*#__PURE__*/React.createElement("td", null, new Date(doc.created_at).toLocaleDateString()), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
      className: "btn-group"
    }, /*#__PURE__*/React.createElement("a", {
      href: doc.document_url,
      target: "_blank",
      rel: "noopener noreferrer",
      className: "btn btn-sm btn-info"
    }, "Ver"), /*#__PURE__*/React.createElement("button", {
      className: "btn btn-sm btn-danger",
      onClick: function onClick() {
        return handleDeleteDocument(doc.id);
      },
      disabled: deleteMutation.isLoading
    }, "Eliminar"))));
  }))))));
};

export default Step3;